import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '@/views/login/Login.vue';
import Order from '@/views/order/Order.vue';
import Inventory from '@/views/inventory/Inventory.vue';
import DetailInventory from '@/views/inventory/DetailInventory.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/orders',
    name: 'orders',
    component: Order,
  },
  {
    path: '/inventories',
    name: 'inventories',
    component: Inventory
  },
  {
    path: '/inventories/:supplier_name/:sku',
    name: 'detail_inventories',
    component: DetailInventory
  },
  {
    path: '/',
    redirect: '/orders',
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('token');

  if (authRequired && !loggedIn) {
    return next({
      path: '/login',
      query: { returnUrl: to.path },
    });
  }

  next();
});

export default router;
